import React, {Component} from 'react';
import './Home.css';
import AgentsAtWorkCompact from "./products/agentsatwork/compact";
import ACallRecorderCompact from "./products/callrecorder/compact";
import RunAndReadCompact from "./products/runandread/compact";
import TimeSlotsCompact from "./products/timeslots/compact";
import UpWriteCompact from "./products/upwrite/compact";
import WiseTalkCompact from "./products/wisetalk/compact";
import StudyCardsCompact from "./products/studycards/compact";
import PhotoDjCompact from "./products/photodj/compact";
import AirSyncCompact from "./products/airsync/compact";
import WifiCameraCompact from "./products/wificamera/compact";
import FooterNavCompact from "./navigation/footer";
import HeaderNavCompact from "./navigation/header";
import VoiceTranslatorCompact from "./products/translator/compact";
import SigmaSpeaksCompact from "./products/sigmaspeaks/compact";
import NextTrainBostonCompact from "./products/nexttrainboston/compact";

let _this;

class Products extends Component {
    constructor(props, context) {
        super(props);
        _this = this;

    }

    render() {
        return <div className="container">
            <HeaderNavCompact navigate={_this.props.navigate}/>
            <div className="card" id="shell4">
                <div id="card_content">
                    <p>
                        <i>We make great products that make people's life a bit better.</i>
                    </p>
                    <p>
                        <i>Our apps and services will help you find the answers to some of your questions and solutions
                            to some of your problems.</i>
                    </p>
                    <div className="fast_nav container">
                        <h3>
                        <ul>
                            <li className="first">
                                <a href="https://github.com/sergenes" target="_blank"
                                   rel="noopener noreferrer">
                                    GitHub
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/in/sergey-neskoromny/" target="_blank"
                                   rel="noopener noreferrer">
                                    LinkedIn
                                </a>
                            </li>
                            <li>
                                <a href="https://medium.com/@sergey-nes" target="_blank"
                                   rel="noopener noreferrer">
                                    Medium
                                </a>
                            </li>
                        </ul>
                        </h3>
                    </div>
                </div>
            </div>
            <br/>
            <AgentsAtWorkCompact navigate={_this.props.navigate}/>
            <br/>
            <SigmaSpeaksCompact navigate={_this.props.navigate}/>
            <br/>
            <RunAndReadCompact navigate={_this.props.navigate}/>
            <br/>
            <TimeSlotsCompact navigate={_this.props.navigate}/>
            <br/>
            <UpWriteCompact navigate={_this.props.navigate}/>
            <br/>
            <StudyCardsCompact navigate={_this.props.navigate}/>
            <br/>
            <PhotoDjCompact navigate={_this.props.navigate}/>
            <br/>
            <ACallRecorderCompact navigate={_this.props.navigate}/>
            <br/>
            <NextTrainBostonCompact navigate={_this.props.navigate}/>
            <br/>
            <VoiceTranslatorCompact navigate={_this.props.navigate}/>
            <br/>
            <WiseTalkCompact navigate={_this.props.navigate}/>
            <br/>
            <AirSyncCompact navigate={_this.props.navigate}/>
            <br/>
            <WifiCameraCompact navigate={_this.props.navigate}/>
            {/*<br/>*/}
            {/*<BabyTubeCompact navigate={_this.props.navigate}/>*/}
            <br/>
            <FooterNavCompact navigate={_this.props.navigate}/>
        </div>
    }
}

export default Products;